export const ROLES_LIST = {
  "VP, Accounts": { serviceGroup: "Client Services", rate: 215 },
  "Account Director": { serviceGroup: "Client Services", rate: 195 },
  "Account Manager": { serviceGroup: "Client Services", rate: 175 },
  "Creative Director": { serviceGroup: "Creative Services", rate: 245 },
  "Associate Creative Director": {
    serviceGroup: "Creative Services",
    rate: 215,
  },
  "Design Director": { serviceGroup: "Creative Services", rate: 215 },
  "Art Director": { serviceGroup: "Creative Services", rate: 195 },
  Copywriter: { serviceGroup: "Creative Services", rate: 175 },
  "Graphic Designer": { serviceGroup: "Creative Services", rate: 175 },
  "Senior Strategist": { serviceGroup: "Strategy", rate: 275 },
  Strategist: { serviceGroup: "Strategy", rate: 195 },
  "Communications Manager": { serviceGroup: "Strategy", rate: 195 },
  "VP, Media Services": { serviceGroup: "Media Services", rate: 215 },
  "Senior Media Director": { serviceGroup: "Media Services", rate: 245 },
  "Media Director": { serviceGroup: "Media Services", rate: 215 },
  "Media Manager": { serviceGroup: "Media Services", rate: 195 },
  "Media Strategist": { serviceGroup: "Media Services", rate: 195 },
  "Media Coordinator": { serviceGroup: "Media Services", rate: 175 },
  Developer: { serviceGroup: "Interactive Services", rate: 195 },
  "Interactive Designer": { serviceGroup: "Interactive Services", rate: 175 },
  "VP, Service Delivery": { serviceGroup: "Service Delivery", rate: 215 },
  "Service Delivery Manager": { serviceGroup: "Service Delivery", rate: 175 },
  "VP, Corporate Development": { serviceGroup: "Operations", rate: 215 },
  "Senior Operations Manager": { serviceGroup: "Operations", rate: 215 },
  "Accounting Manager": { serviceGroup: "Operations", rate: 215 },
};
